import { AnimatePresence } from "framer-motion";
import {
  Container,
  ContainerWrapper,
  MainContainer,
} from "../../style/main/main";
import MainHeader from "./main.header";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import MainFooter from "./main.footer";

const MainLayout = () => {
  const location = useLocation(); // 현재 경로 가져오기

  useEffect(() => {
    // 페이지 이동 시 스크롤을 맨 위로 이동
    window.scrollTo(0, 0);
  }, [location.pathname]); // 경로 변경될 때 실행

  const pathsWithAutoHeight = ["home"];

  return (
    <MainContainer>
      <MainHeader />
      <AnimatePresence mode="wait" initial={true}>
        <ContainerWrapper>
          <Container
            key={location.pathname} // 경로가 변경될 때마다 애니메이션 트리거
            initial={{ opacity: 0, y: 20 }} // 초기 상태 (살짝 오른쪽에서 시작)
            animate={{ opacity: 1, y: 0 }} // 나타날 때
            exit={{ opacity: 0, y: -20 }} // 사라질 때 (왼쪽으로 이동하며 사라짐)
            transition={{ duration: 0.3 }} // 애니메이션 속도
            className={
              pathsWithAutoHeight.some((path) =>
                location.pathname.includes(path)
              )
                ? "auto-height"
                : ""
            }
          >
            <Outlet />
          </Container>
        </ContainerWrapper>
      </AnimatePresence>
      <MainFooter />
    </MainContainer>
  );
};

export default MainLayout;
